"use client";
import dynamic from "next/dynamic";
import LazyLoad from "@/components/common/LazyLoad";

import HeaderLandingPage from "../components/HeaderLandingPage";
import HeroSection from "../components/desktop/homepage/HeroSectionDesktop";
import Breadcrumb from "../components/Breadcrumb";
const BottomNavigationBar = dynamic(() => import("../components/BottomNavigationBar"), { ssr: false });
import { useLandingPage } from "@/hooks/customer/useLandingPage";
const ExperienceYouWillNeverForgetDesktop = dynamic(
  () =>
    import("../components/desktop/homepage/ExperienceYouWillNeverForgetDesktop"),
);
const TripsMobile = dynamic(
  () => import("../components/mobile/homepage/TripsMobile"),
);
const WhyChooseTripsAdoraDesktop = dynamic(
  () => import("../components/desktop/homepage/WhyChooseTripsAdoraDesktop"),
);
const WhereToGoNextDesktop = dynamic(
  () => import("../components/WhereToGoNextDesktop"),
);
const LanguageAndCurrencyMobileSection = dynamic(
  () =>
    import("../components/mobile/homepage/LanguageAndCurrencyMobileSection"),
);
const WhereToMoveMobile = dynamic(
  () => import("../components/mobile/homepage/WhereToMoveMobile"),
);
const ToursSectionDesktop = dynamic(
  () => import("../components/desktop/homepage/ToursSectionDesktop"),
);
const TopCountriesSectionDesktop = dynamic(
  () => import("../components/desktop/homepage/TopCountriesSectionDesktop"),
);
const ConsultationBannerDesktop = dynamic(
  () => import("../components/desktop/homepage/ConsultationBannerDesktop"),
);
const SupplierPromoDesktop = dynamic(
  () => import("../components/desktop/homepage/SupplierPromoDesktop"),
);
const NewsletterSectionDesktop = dynamic(
  () => import("../components/desktop/homepage/NewsletterSectionDesktop"),
);
const Footer = dynamic(() => import("../components/desktop/FooterDesktop"));

import React, { useState, useEffect } from "react";

const LandingPage = () => {
  const { heroRef } = useLandingPage();
  const [interacted, setInteracted] = useState(false);

  useEffect(() => {
    const handleInteraction = () => setInteracted(true);
    window.addEventListener("scroll", handleInteraction, { once: true, passive: true });
    window.addEventListener("mousemove", handleInteraction, { once: true, passive: true });
    window.addEventListener("touchstart", handleInteraction, { once: true, passive: true });

    return () => {
      window.removeEventListener("scroll", handleInteraction);
      window.removeEventListener("mousemove", handleInteraction);
      window.removeEventListener("touchstart", handleInteraction);
    };
  }, []);

  return (
    <div className="min-h-screen bg-page-white">
      {/* Header */}
      <HeaderLandingPage heroRef={heroRef} />

      {/* bottom navigation bar */}
      <BottomNavigationBar />

      {/* breadcrumb navigation based on the current URL path. */}
      <Breadcrumb />

      {/* hero section */}
      <HeroSection heroRef={heroRef} interacted={interacted} />

      {/* highlighting popular travel destinations */}
      {interacted && (
        <>
          <WhereToMoveMobile />

          {/* tour packages */}
          <ToursSectionDesktop />

          {/* top countries */}
          <div id="careers">
            <TopCountriesSectionDesktop />
          </div>

          {/* Banner promoting travel consultation services */}
          <ConsultationBannerDesktop />

          {/* travel experiences */}
          <ExperienceYouWillNeverForgetDesktop />

          {/* Supplier promo */}
          <div id="about-us">
            <SupplierPromoDesktop />
          </div>

          {/* Why Choose TripsAdora */}
          <WhyChooseTripsAdoraDesktop />

          {/* Newsletter subscription */}
          <div id="contact-us">
            <NewsletterSectionDesktop />
          </div>

          {/* trip categories */}
          <TripsMobile />

          {/* suggesting future travel */}
          <WhereToGoNextDesktop />

          {/* language and currency preferences */}
          <LanguageAndCurrencyMobileSection />

          {/* Footer */}
          <Footer />
        </>
      )}
    </div>
  );
};

export default LandingPage;
